export interface TransferToFxStockWallet {
    TransferAmount: string
}
export const TransferToFxStockWalletInitialValues: TransferToFxStockWallet = {
    TransferAmount: ""
}